
    <div class="refresh" *ngIf="editMode">
      <span class="glyphicon glyphicon-refresh" (click)="refresh()"></span>
    </div>
    <div [innerHTML]="cmsBlockModel?.content | html"></div>
  